import styled from 'styled-components';
import { device, hexToRGB } from '@/styles/helpers';

export const ScLoyaltyBenefits = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 32px;
  width: 100%;
  max-width: 420px;

  & .step-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    & .title {
      font-weight: 700;
      text-transform: uppercase;
      text-align: start;
      & .step {
        color: ${({ theme }) => theme.yellowColor};
      }
    }
    & .description {
      text-align: start;
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    }
  }

  & .cta-btn {
    width: 100%;
    width: 280px;
    @media (${device.mobileS}) {
      margin: 0 auto;
    }
  }

  @media (${device.mobileS}) {
    max-width: none;
    align-items: center;
    & .step-wrapper {
      align-items: center;
      & .title {
        text-align: center;
      }
      & .description {
      display: flex;
      align-items: center;
      text-align: center;
    }
    }
  }
`;
